//@flow
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import {
    TPN_TIER_MEMBER,
    TPN_TIER_BRONZE,
    TPN_TIER_SILVER,
    TPN_TIER_GOLD,
    TPN_TIER_PLATINUM,
} from 'dibs-trade-rewards-progress/exports/tpnStatusCodes';

function CashbackBenefit({
    cashbackAmount,
    pointsPerReward = 5000,
}: {
    cashbackAmount: number,
    pointsPerReward?: number,
}) {
    return (
        <FormattedMessage
            id="abt.loyaltyModules.getMobileChartBenefits.cashbackBenefit"
            defaultMessage="{cashbackAmount} Cash Back for every {pointsPerReward} Points"
            values={{
                cashbackAmount: (
                    <FormattedNumber
                        currency="USD"
                        maximumFractionDigits={0}
                        minimumFractionDigits={0}
                        style="currency"
                        value={cashbackAmount}
                    />
                ),
                pointsPerReward: <FormattedNumber value={pointsPerReward} />,
            }}
        />
    );
}

const sourcingBenefit = {
    copy: (
        <FormattedMessage
            id="abt.loyaltyModules.getMobileChartBenefits.sourcingBenefit"
            defaultMessage="Sourcing Service"
        />
    ),
    name: 'sourcing',
};

const eventBenefit = {
    copy: (
        <FormattedMessage
            id="abt.loyaltyModules.getMobileChartBenefits.eventBenefit"
            defaultMessage="Exclusive 1stdibs Events"
        />
    ),
    name: 'events',
};

const vipBenefit = {
    copy: (
        <FormattedMessage
            id="abt.loyaltyModules.getMobileChartBenefits.vipBenefit"
            defaultMessage="VIP Experiences"
        />
    ),
    name: 'vip',
};

const profileBenefit = {
    copy: (
        <FormattedMessage
            id="abt.loyaltyModules.getMobileChartBenefits.profileBenefit"
            defaultMessage="Published Profile"
        />
    ),
    name: 'profile',
};

const firmFeatureBenefit = {
    copy: (
        <FormattedMessage
            id="abt.loyaltyModules.getMobileChartBenefits.firmFeatureBenefit"
            defaultMessage="360&deg; Firm Feature*"
        />
    ),
    name: 'firmFeature',
};

const designerConnectionBenefit = {
    copy: (
        <FormattedMessage
            id="abt.loyaltyModules.getMobileChartBenefits.designerConnectionBenefit"
            defaultMessage="Designer Connection"
        />
    ),
    name: 'designerConnection',
};

const socialPostBenefit = {
    copy: (
        <FormattedMessage
            id="abt.loyaltyModules.getMobileChartBenefits.socialPostBenefit"
            defaultMessage="Social Post*"
        />
    ),
    name: 'social-post',
};

const editorialCoverageBenefit = {
    copy: (
        <FormattedMessage
            id="abt.loyaltyModules.getMobileChartBenefits.editorialCoverageBenefit"
            defaultMessage="Editorial Coverage*"
        />
    ),
    name: 'editorial-coverage',
};

const printFeatureBenefit = {
    copy: (
        <FormattedMessage
            id="abt.loyaltyModules.getMobileChartBenefits.printFeatureBenefit"
            defaultMessage="Print Feature*"
        />
    ),
    name: 'print-feature',
};

function BuyerProtectionBenefit({ days }: { days: number }) {
    return (
        <FormattedMessage
            id="abt.loyaltyModules.getMobileChartBenefits.buyerProtection"
            defaultMessage="{days} Days Enahnced Buyer Protection"
            values={{
                days: <FormattedNumber value={days} />,
            }}
        />
    );
}

const sellerInfoBenefit = {
    copy: (
        <FormattedMessage
            id="abt.loyaltyModules.getMobileChartBenefits.sellerInfoBenefit"
            defaultMessage="Additional Seller Information"
        />
    ),
    name: 'seller-info',
};

const benefitsMap = {
    [TPN_TIER_MEMBER]: [
        {
            copy: <CashbackBenefit cashbackAmount={50} />,
            name: 'cashback-member',
        },
        sourcingBenefit,
    ],
    [TPN_TIER_BRONZE]: [
        {
            copy: <CashbackBenefit cashbackAmount={50} />,
            name: 'cashback-bronze',
        },
        sourcingBenefit,
        eventBenefit,
        profileBenefit,
        designerConnectionBenefit,
    ],
    [TPN_TIER_SILVER]: [
        {
            copy: <CashbackBenefit cashbackAmount={50} />,
            name: 'cashback-silver',
        },
        sourcingBenefit,
        eventBenefit,
        profileBenefit,
        designerConnectionBenefit,
        socialPostBenefit,
        {
            copy: <BuyerProtectionBenefit days={30} />,
            name: 'buyer-protection-silver',
        },
    ],
    [TPN_TIER_GOLD]: [
        {
            copy: <CashbackBenefit cashbackAmount={100} />,
            name: 'cashback-gold',
        },
        sourcingBenefit,
        eventBenefit,
        vipBenefit,
        profileBenefit,
        designerConnectionBenefit,
        firmFeatureBenefit,
        socialPostBenefit,
        editorialCoverageBenefit,
        {
            copy: <BuyerProtectionBenefit days={60} />,
            name: 'buyer-protection-gold',
        },
        sellerInfoBenefit,
    ],
    [TPN_TIER_PLATINUM]: [
        {
            copy: <CashbackBenefit cashbackAmount={125} />,
            name: 'cashback-platinum',
        },
        sourcingBenefit,
        eventBenefit,
        vipBenefit,
        profileBenefit,
        designerConnectionBenefit,
        firmFeatureBenefit,
        socialPostBenefit,
        editorialCoverageBenefit,
        printFeatureBenefit,
        {
            copy: <BuyerProtectionBenefit days={90} />,
            name: 'buyer-protection-platinum',
        },
        sellerInfoBenefit,
    ],
};

export function getBenefits(tpnTierCode: ?string) {
    // istanbul ignore next
    return tpnTierCode ? benefitsMap[tpnTierCode] : [];
}
